import FeedbackDialog from './FeedbackDialog';
import BillingFeedbackDialog from './FeedbackDialog.billing';
import { isBilling, isKazan } from '@constants/project';
import OkdeskForm from './OkdeskForm';

const FeedbackDialogComponent = isBilling
  ? BillingFeedbackDialog
  : isKazan
  ? OkdeskForm // для УИТиС
  : FeedbackDialog;

export default FeedbackDialogComponent;
